import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCocktail: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"cocktail, drink"} maskId="square-filled-radius-0-stroke-1-IconCocktail"><path d="M1.29492 3L11.4994 13.2361V21H6.99939V22H16.9994V21H12.4994V13.2361L22.7039 3H1.29492Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCocktail;
